import { HallOfFameGameDto } from "dtos/hall-of-fame/HallOfFameGameDto";
import { Link } from "react-router-dom";
import { RouteLink } from "Routes";
import { Fragment, useContext } from "react";
import { GlobalContext } from "contexts/GlobalContext";

export const HallOfFameGameCard = (props: { game: HallOfFameGameDto }) => {
    const { game } = props;
    const { regionNames } = useContext(GlobalContext);

    return (
        <Link to={RouteLink.hallOfFameGame(game.code)} className="text-decoration-none">
            <div className="card h-100 card-hover border-dark">
                <div className="card-header bg-dark hstack gap-2 px-2" style={{ height: 75 }}>
                    <span className="fs-5">🏆</span>
                    <h5 className="h6 text-white align-self-center text-break">{game.title}</h5>
                </div>

                <div
                    style={{
                        height: 190,
                        backgroundImage: `url(${game.imageUrl})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                />

                <div className="card-body px-2 hstack border-top border-dark">
                    <div className="hstack gap-2 small ms-1 justify-content-between flex-grow-1">
                        <div className="d-flex align-items-center gap-1 text-muted lh-1">
                            {game.region && <div className="fw-bolder"> {game.region},</div>}
                            {game.country && (
                                <Fragment>
                                    <span>{regionNames.of(game.country) || game.country}</span>
                                    <img
                                        src={`https://flagcdn.com/16x12/${game.country.toLowerCase()}.webp`}
                                        alt={regionNames.of(game.country) || game.country}
                                    />
                                </Fragment>
                            )}
                        </div>

                        <div className="d-flex justify-content-between align-items-center lh-1">
                            <span className="fw-bolder text-nowrap">{game.playerCount}🧑</span>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};
